import React, { useContext, useState } from 'react';

import KibDialog from '@chewy/kib-dialog-react';
import KibCropper from '@chewy/kib-cropper-react';
import { KibButtonNew } from '@chewy/kib-controls-react';
import { useLocation } from 'react-router';

import './cropperModal.scss';
import { CropData, useImageUpload } from '../ImageUploadContext/ImageUploadContext';
import AnalyticsContext from '../../../context/AnalyticsContext';

export const CropperModal = ({
  aspectRatio,
  circleCrop,
  title = 'Upload Image',
}: {
  aspectRatio?: string;
  circleCrop?: boolean;
  title?: String;
}) => {
  const {
    isCropperVisible,
    setIsCropperVisible,
    handleCancelCropper,
    croppedImage,
    handleCompleteCrop,
  } = useImageUpload();

  const location = useLocation();
  const analytics = useContext(AnalyticsContext);
  const isEdit = location.pathname.toLowerCase().includes('edit');

  const [cropState, setCropState] = useState<CropData | null>(null);

  const onClickCancel = () => {
    setCropState(null);
    analytics.trackEvent(
      isEdit ? 'new-pet-profile-edit' : 'new-pet-profile',
      'personalized_avatar',
      'crop_cancel',
    );
    handleCancelCropper();
  };

  return (
    <KibDialog
      className="cropper-modal"
      title={title}
      visible={isCropperVisible}
      updateVisible={(value) => setIsCropperVisible(value)}
      theme="chirp"
      data-testid="cropper-modal-testid"
    >
      {croppedImage && (
        <KibCropper
          imageSrc={croppedImage}
          change={setCropState}
          aspectRatio={aspectRatio || '1:1'}
          circleCrop={circleCrop === undefined ? true : circleCrop}
          data-testid="cropper-testid"
        />
      )}
      <div className="cropper-modal__controls">
        <KibButtonNew
          onClick={onClickCancel}
          emphasis="tertiary"
          theme="utility"
          data-testid="cropper-cancel"
        >
          Cancel
        </KibButtonNew>
        <KibButtonNew
          onClick={(event) => {
            event.preventDefault();
            analytics.trackEvent(
              isEdit ? 'new-pet-profile-edit' : 'new-pet-profile',
              'personalized_avatar',
              'crop_continue',
            );
            handleCompleteCrop(cropState);
          }}
          data-testid="cropper-continue"
        >
          Continue
        </KibButtonNew>
      </div>
    </KibDialog>
  );
};
